<template>
  <div :class="[$style.field, $style.booleanField]">
    <span :class="$style.label">Log to {{crmName}}</span>
    <toggle-button
      :id="id"
      v-model="value"
      :name="id"
      :sync="true"
      color="#24f7db"></toggle-button>
    <p v-show="error && showError">{{error}}</p>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex'

  const { mapState, mapMutations } = createNamespacedHelpers('activitySummary')

  export default {
    data () {
      return {
        id: 'is_internal',
        value: true,
        showError: false,
        team: this.$_activitySummary_config.getTeam()
      }
    },
    computed: {
      ...mapState([
        'activity',
        'formErrors'
      ]),
      crmName () {
        return this.team.crm.name
      },
      error () {
        return this.formErrors[this.id]
      }
    },
    watch: {
      value (value) {
        this.handleValue(!value)
      }
    },
    created () {
      this.$_activitySummary_config.EventBus.$on('ACTIVITY_FORM_SUBMITTED', () => {
        this.showError = true
      })

      this.value === this.activity.isInternal
        ? this.handleValue(!this.value)
        : this.value = !this.activity.isInternal
    },
    methods: {
      ...mapMutations([
        'upsertFormData',
        'setInternalFlag'
      ]),
      handleValue (value) {
        this.showError = false
        this.setInternalFlag(value)
        this.upsertFormData({
          id: this.id,
          value
        })
        this.$_activitySummary_config.EventBus.$emit('UPDATED_INTERNAL_INPUT')
      }
    }
  }
</script>

<style module lang="less" src="../custom-section/fields/boolean-field.less"></style>



// WEBPACK FOOTER //
// log-crm-toggle.vue?628752ec